import { render, staticRenderFns } from "./AiSyntaxDialog.vue?vue&type=template&id=a36582fc&scoped=true&"
import script from "./AiSyntaxDialog.vue?vue&type=script&lang=ts&"
export * from "./AiSyntaxDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AiSyntaxDialog.vue?vue&type=style&index=0&id=a36582fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36582fc",
  null
  
)

export default component.exports